/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Form from "../ui/form/Form";
import Button from "../ui/Button";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants/constants";
import { useForm } from "react-hook-form";
import FormFieldsWrapper from "../ui/form/FormFieldsWrapper";
import ButtonGroup from "../ui/ButtonGroup";
import { useClientFields } from "../../lib/react-query/useClientFields";
import LoadingIndicator from "../LoadingIndicator";
import ClientFieldsGroup from "./ClientFieldsGroup";

const StyledClientProfileForm = styled.div`
  display: grid;
  gap: 24px;
  place-items: start;
  padding: 24px;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  border-radius: 1rem;
`;

const ClientProfileForm = () => {
  const form = useForm();
  const navigate = useNavigate();
  const { data: clientFields, isLoading: clientFieldsLoading } = useClientFields();

  if (clientFieldsLoading) {
    return <LoadingIndicator page />;
  }

  return (
    <StyledClientProfileForm>
      <Form>
        <FormFieldsWrapper>
          <ClientFieldsGroup form={form} fields={clientFields} readOnly={true} hasClientData={true} />
        </FormFieldsWrapper>
      </Form>
      <ButtonGroup>
        <Button variant="outline" title="edit_profile" onClick={() => navigate(ROUTES.CLIENT_EDIT)} />
        <Button variant="outline" title="Change password" onClick={() => navigate(ROUTES.CLIENT_PASSWORD_CHANGE)} />
      </ButtonGroup>
    </StyledClientProfileForm>
  );
};

export default ClientProfileForm;
